import { jsx } from "panel";
import { DropMenuEl } from "common/components/drop-menu";
import { PopoverCardEl } from "common/components/popover-card";
import { PropertiesMenuEl } from "common/query-builder/query-block/properties-menu";
import { VIEWS } from "./types";
export function template() {
  var _a;
  const { dropMenuOpen, view } = this.state;
  return /* @__PURE__ */ jsx("div", {
    sel: ".actions-popover-container"
  }, /* @__PURE__ */ jsx(DropMenuEl, {
    attrs: {
      open: this.attr(`open`) && dropMenuOpen,
      "prevent-close-selectors": [`mp-create-entity-modal`, ...this.attr(`prevent-close-selectors`)],
      "experimental-positioning": true
    },
    on: {
      change: this.helpers.handleDropMenuChange,
      click: (ev) => ev.stopPropagation()
    },
    props: {
      positionParent: (_a = this.state.positionParent) != null ? _a : this
    }
  }, view === VIEWS.BREAKDOWN ? /* @__PURE__ */ jsx(PropertiesMenuEl, {
    attrs: {
      "disabled-items": this.helpers.breakdownDisabledItemsMap(),
      "event-names": [this.attr(`event`)],
      open: this.attr(`open`),
      "project-id": this.helpers.getProjectId(),
      "workspace-id": this.attr(`workspace-id`)
    },
    on: {
      select: this.helpers.handleBreakdownMenuSelect
    }
  }) : /* @__PURE__ */ jsx(PopoverCardEl, {
    attrs: {
      "button-options": this.attr(`button-options`),
      title: this.attr(`title`),
      subtitle: this.attr(`subtitle`),
      "is-segmented": this.attr(`is-segmented`)
    },
    on: {
      action: this.helpers.handlePopoverAction,
      close: this.helpers.handlePopoverClose
    }
  }, /* @__PURE__ */ jsx("slot", null), /* @__PURE__ */ jsx("slot", {
    attrs: { name: `footer`, slot: `footer` }
  }))));
}
